
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchOrganizations } from "@/services/api";
import type { Organization, PaginationMeta } from "@/types";

export const useOrganizations = (limit: number = 10) => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit,
  });

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["organizations", pagination.page, pagination.limit],
    queryFn: () => fetchOrganizations(pagination.limit, (pagination.page - 1) * pagination.limit),
  });

  const organizations: Organization[] = data?.data || [];
  const meta: PaginationMeta | undefined = data?.meta;

  const goToPage = (page: number) => {
    setPagination((prev) => ({
      ...prev,
      page,
    }));
  };

  return {
    organizations,
    meta,
    isLoading,
    isError,
    pagination,
    goToPage,
    refetch,
  };
};
